import { useQuery } from "@tanstack/react-query";

import { createAppsDescriptionQuery } from "./options";

export default function useAppsDescriptionQuery() {
    return useQuery(createAppsDescriptionQuery());
}
